export default {
  REGISTER: 'MODALS/REGISTER',
  OPEN: 'MODALS/OPEN',
  CLOSE: 'MODALS/CLOSE',
  DESTROY: 'MODALS/DESTROY',
};
